import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ConstantsService } from '../services/constants.service';
import { environment } from "../../environments/environment"
import { AdminService } from '../services/admin.service';
import { Router } from '@angular/router';
import { UrlConstants } from '../services/url-constants';
import { DataService } from '../services/data.service';
@Component({
  selector: 'app-admin-uploaded',
  templateUrl: './admin-uploaded.component.html',
  styleUrls: ['./admin-uploaded.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class AdminUploadedComponent implements OnInit {
  public videos;
  public uploadedVideos = [];
  public isChecked = false;
  public videoList = [];
  public profilePicture;
  public isLoading = false;
  public isProcessing = false;
  public uploadSkeltonArray = [];
  public isdisabled = true;
  public urlPrefix = environment.S3_URL_PRFIX;
  public folderName = this.constants.UPLOADEDTOVIEO_TXT;
  public sThreeFolder = 'pending';
  public liveVideo = true;
  public offlineVideo = false;
  public liveVideosArray = [];
  public from = "admin,uploaded"
  public liveVideos = [];
  public submitVideosList = [];
  count = 0;
  p: number = 1;
  videoTitle: any;
  latestVideosOnly = false;
  tempStorageForVideos:any;
  constructor(
    public constants: ConstantsService,
    private adminservice: AdminService,
    private router: Router,
    private dataService: DataService,
    private urlConstants: UrlConstants,
  ) {
    var uploadSkelton = [
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
    ]
    this.uploadSkeltonArray = uploadSkelton;
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.isdisabled = true;
    this.getLiveVideos()
  }
  onCheckedAll($event) {
    let startIndex = (this.p * 250) - 250;
    let lastIndex = (this.p * 250);
    let selectedItems = this.liveVideos.slice(startIndex, lastIndex)
    this.isChecked = !this.isChecked
    if (this.isChecked) {
      this.videoList = [];
      selectedItems.forEach(element => {
        element.vimeoToken !== undefined ? element['vimeoToken'] = element.vimeoToken : element['vimeoToken'] = this.constants.TP_VIMEO_TOKEN_TXT
        this.videoList.push({
          url1: element.url1,
          url2: element.url2,
          author: element.author,
          cityLocation: element.cityLocation,
          Latitude: element.Latitude ? element.Latitude : '',
          Longitude: element.Longitude ? element.Longitude : '',
          Interiors: element.Interiors,
          Water :  element.Water,
          Snow: element.Snow,
          Animals: element.Animals,
          DayVideo: element.DayVideo,
          City: element.City,
          Rain: element.Rain,
          Nature: element.Nature,
          Night: element.Night,
          dateRecording: element.dateRecording,
          timeRecording: element.timeRecording,
          vimeoToken: element.vimeoToken,
          liveSequenceId: element.liveSequenceId
        })

      });
    }
    else {
      this.videoList = [];
    }
  }
  private setting = {
    element: {
      dynamicDownload: null as HTMLElement
    }
  }
  onclickGenerateTxt() {
    if (this.videoList.length !== 0) {
      this.dyanmicDownloadByHtmlTag({
        fileName: 'videos',
        text: JSON.stringify(this.videoList, null, " ")
      });
    }
    else {
      document.getElementById("error-message").innerHTML = this.constants.SELECT_VIDEO_TXT
      document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT
    }
  }
  private dyanmicDownloadByHtmlTag(arg: {
    fileName: string,
    text: string
  }) {
    if (!this.setting.element.dynamicDownload) {
      this.setting.element.dynamicDownload = document.createElement('a');
    }
    const element = this.setting.element.dynamicDownload;
    const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
    element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
    element.setAttribute('download', arg.fileName);

    var event = new MouseEvent("click");
    element.dispatchEvent(event);
  }
  onClickVideoTitle(item, event) {
    let shareUrl = `${window.location.origin}/Window/${item.videoId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      window.open(`/Window/${item.videoId}`, '_blank');
    })
    document.getElementById(`${event.target.id}`).innerHTML = "URL copied"
  }
  onSelectTbleRow(video, event) {
    video.vimeoToken !== undefined ? video['vimeoToken'] = video.vimeoToken : video['vimeoToken'] = this.constants.TP_VIMEO_TOKEN_TXT
    if (event.target.checked) {
      this.videoList.push({
        url1: video.url1,
        url2: video.url2,
        author: video.author,
        cityLocation: video.cityLocation,
        Latitude: video.Latitude ? video.Latitude : '',
        Longitude: video.Longitude ? video.Longitude : '',
        Interiors: video.Interiors,
        Water: video.Water,
        Snow: video.Snow,
        Animals: video.Animals,
        DayVideo: video.DayVideo,
        City: video.City,
        Rain: video.Rain,
        Nature: video.Nature,
        Night: video.Night,
        dateRecording: video.dateRecording,
        timeRecording: video.timeRecording,
        vimeoToken: video.vimeoToken
      })
    }
    else {
      this.videoList = this.videoList.filter(data => data.url1 !== video.url1)
    }
  }
  Search() {
    if (this.videoTitle === "") {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      },500);
    }
    else {
      this.liveVideosArray = this.liveVideosArray.filter(res => {
        return res.videoTitle.toLowerCase().match(this.videoTitle.toLowerCase());
      })
    }
  }
  closeErrorAlert() {
    document.getElementById("error-alert").style.display = this.constants.NONE_TXT
  }
  closeSuccessAlert() {
    document.getElementById("videoTitle").innerHTML = "";
    document.getElementById("success-alert").style.display = this.constants.NONE_TXT
  }
  onClickName(video) {
    let data = {
      email: video.emailId,
      name: video.author,
      admin:true
    }
    this.adminservice.shareUserData(data);
    this.router.navigate(['./user/mywindow'])
  }
  getLiveVideos() {
    const params = [
      { param: '{object}', value: 'getLiveVideos' },
      { param: '{id1}', value: null },
      { param: '{id2}', value: 'getLiveVideos' },
    ];
    this.dataService.getData(this.urlConstants.getUri(this.urlConstants.getList, params)).subscribe((data: any) => {
      this.liveVideos = data.Items;
      this.isLoading = false;
      this.isdisabled = false;
    }, (error) => {
      console.log(error);
      document.getElementById("error-message").innerHTML = this.constants.FETCH_ERROR;
      document.getElementById("error-alert").style.display = this.constants.BLOCK_TXT;
      this.isLoading = false;
      this.isdisabled = false;
    })
  }
  onClickOnShowLatestVideosOnly() {
    if (this.latestVideosOnly) {
      this.tempStorageForVideos = this.liveVideos;
      this.liveVideos = this.liveVideos.filter((el) => el.hasOwnProperty("isLatest"))
    } else {
      this.liveVideos = this.tempStorageForVideos;
    }
  }
}
